var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync 1",
    clipPath: "url(#clip0_2758_456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.02502V4.1625C12 4.57671 11.6642 4.9125 11.25 4.9125H9.11252C8.69831 4.9125 8.36252 4.57671 8.36252 4.1625C8.36252 3.74829 8.69831 3.4125 9.11252 3.4125H9.68557C8.85741 2.22551 7.50016 1.5 6 1.5C4.13346 1.5 2.48794 2.62296 1.80783 4.36085C1.65684 4.74659 1.22175 4.93687 0.836063 4.78594C0.450328 4.63498 0.260016 4.19991 0.410977 3.8142C0.845953 2.70272 1.59567 1.7539 2.57909 1.0703C3.58636 0.370102 4.76927 0 6 0C7.23073 0 8.41364 0.370102 9.42091 1.07027C9.82113 1.34848 10.1827 1.67065 10.5 2.0298V2.02505C10.5 1.61084 10.8358 1.27505 11.25 1.27505C11.6642 1.27505 12 1.61081 12 2.02502ZM11.1639 7.21409C10.7782 7.0631 10.3432 7.25346 10.1922 7.63917C9.51206 9.37706 7.86654 10.5 6 10.5C4.53171 10.5 3.2003 9.80498 2.36789 8.6625H2.88748C3.30169 8.6625 3.63748 8.32671 3.63748 7.9125C3.63748 7.49829 3.30169 7.1625 2.88748 7.1625H0.75C0.335789 7.1625 0 7.49829 0 7.9125V10.05C0 10.4642 0.335789 10.8 0.75 10.8C1.16421 10.8 1.5 10.4642 1.5 10.05V9.97022C1.81734 10.3294 2.17887 10.6515 2.57909 10.9297C3.58636 11.6299 4.76927 12 6 12C7.23073 12 8.41364 11.6299 9.42091 10.9297C10.4043 10.2461 11.154 9.2973 11.589 8.18583C11.74 7.80012 11.5497 7.36505 11.1639 7.21409Z",
    fill: "#DE9F22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2758_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSync);
export default __webpack_public_path__ + "static/media/icon_sync.bc4cb0996253696e18ce458c248190e0.svg";
export { ForwardRef as ReactComponent };